import React, { createContext, useContext, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import PropTypes from "prop-types";

// Actions
import { parseFetchOptions } from "../state/user/actions";

// Config
import { getShareWithRecipientsUrl } from "../config/apiConfig";

// Hooks
import { useAppInsights } from "../utils/telemetry/AppInsights";

const RecipientsContext = createContext();

export const useRecipients = () => useContext(RecipientsContext);

const RecipientsProvider = ({ children }) => {
  const dispatch = useDispatch();
  const { caseId } = useParams();
  const { data } = useSelector(s => s.caseDetail);
  const [loading, setLoading] = useState(false);
  const [recipients, setRecipients] = useState([]);
  const { trackException } = useAppInsights();

  const loadRecipients = () => {
    dispatch(
      parseFetchOptions(({ headers }) => {
        fetch(getShareWithRecipientsUrl(caseId), { headers })
          .then(res => res.json())
          .then(result => {
            setRecipients(result);
          })
          .catch(() => {
            trackException(`Failed to get recipients from case ${caseId}`);
          })
          .finally(() => {
            setLoading(false);
          });
      })
    );
  };

  useEffect(() => {
    if (!loading && data?.incident?.location) {
      setLoading(true);
      loadRecipients();
    }
  }, [data]);

  return (
    <RecipientsContext.Provider value={{ recipients, loading }}>
      {children}
    </RecipientsContext.Provider>
  );
};

RecipientsProvider.propTypes = {
  children: PropTypes.node.isRequired
};

export default RecipientsProvider;
